import * as Sentry from '@sentry/browser'
import ReactGA from 'react-ga4'
import { browserHistory } from 'react-router'
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createLogger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import rootReducer from './actions'
import { AuthState } from './actions/authActions'
import { axiosSetting } from './axiosSettings'
import createGoogleAnalyticsMiddleware from './middleware/createGoogleAnalyticsMiddleware'
import rootSaga from './sagas'

ReactGA.initialize([
  {
    trackingId: process.env.ADMIN_TRACKING_ID || ''
  },
  {
    trackingId: process.env.ALL_DOMAIN_TRACKING_ID || '',
    gaOptions: {
      // クロスドメイン用の設定。ステージングはサブドメイン判定されなさそうなので。
      allowLinker: true
    }
  }
])

Sentry.init({
  dsn: process.env.SENTRY_DSN_PROJECT,
  release: `release-${process.env.STAGE}-${process.env.REVISION}`,
  environment: process.env.STAGE
})

const sagaMiddleware = createSagaMiddleware()

const middlewares = [
  routerMiddleware(browserHistory),
  sagaMiddleware,
  createGoogleAnalyticsMiddleware()
  // something Middleware...
  // something Middleware...
]

if (process.env.NODE_ENV !== 'production') {
  const logger = createLogger()
  middlewares.push(logger)
}

const appliedMiddlewares = applyMiddleware(...middlewares)

const store = createStore(rootReducer, composeWithDevTools(appliedMiddlewares))

axiosSetting(store)

sagaMiddleware.run(rootSaga)

export interface CustomPcStore {
  auth: AuthState
  projects: any
  questions: any
  routing: any
  editor: any
  presentation: any
}

export const history = syncHistoryWithStore(browserHistory, store, { adjustUrlOnReplay: false })
export default store
